export const services = [
  {
    id: 1,
    title: 'SEO Optimization',
    description: 'Boost your search rankings and drive organic traffic with our proven SEO strategies. We optimize every aspect of your online presence.',
    icon: 'search'
  },
  {
    id: 2,
    title: 'Social Media Marketing',
    description: 'Engage your audience across all platforms. We create compelling campaigns that build communities and drive conversions.',
    icon: 'share2'
  },
  {
    id: 3,
    title: 'Content Creation',
    description: 'Captivating content that tells your story. From blogs to videos, we craft content that resonates with your target audience.',
    icon: 'fileText'
  },
  {
    id: 4,
    title: 'SEO Text Creation',
    description: 'Expert copywriting optimized for search engines. We create content that ranks high and converts visitors into customers.',
    icon: 'type'
  },
  {
    id: 5,
    title: 'Email Marketing',
    description: 'Reach your customers directly with personalized email campaigns. Build relationships and drive sales with targeted messaging.',
    icon: 'mail'
  },
  {
    id: 6,
    title: 'Website Design',
    description: 'Beautiful, high-performing websites that convert. We design responsive sites that provide exceptional user experiences.',
    icon: 'monitor'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Johnson',
    company: 'TechStart Inc.',
    text: 'Netex Digital transformed our online presence. Our organic traffic increased by 300% in just 6 months!',
    rating: 5
  },
  {
    id: 2,
    name: 'Michael Chen',
    company: 'GreenLeaf Co.',
    text: 'The team at Netex Digital is incredible. Their social media strategies helped us build a community of 50K+ engaged followers.',
    rating: 5
  },
  {
    id: 3,
    name: 'Emily Rodriguez',
    company: 'Fashion Forward',
    text: 'Professional, creative, and results-driven. Netex Digital exceeded all our expectations with their email marketing campaigns.',
    rating: 5
  }
];

export const stats = [
  { label: 'Clients Served', value: '200+' },
  { label: 'Projects Completed', value: '500+' },
  { label: 'Years Experience', value: '10+' }
];

export const aboutContent = {
  mission: 'At Netex Digital, we believe in the power of digital transformation. Our mission is to help businesses thrive in the digital age by providing cutting-edge marketing solutions that deliver measurable results.',
  vision: 'We envision a world where every business, regardless of size, has access to world-class digital marketing strategies that drive growth and success.',
  values: [
    'Excellence in execution',
    'Data-driven decisions',
    'Transparent communication',
    'Continuous innovation',
    'Client success first'
  ]
};